export function extractIframeSource(value: string | null | undefined): string {
  const trimmedValue = value?.trim() ?? ''
  const quotedSource = trimmedValue.match(/<iframe\b[^>]*\bsrc\s*=\s*(["'])(.*?)\1/i)?.[2]
  const unquotedSource = trimmedValue.match(/<iframe\b[^>]*\bsrc\s*=\s*([^\s>]+)/i)?.[1]

  return (quotedSource ?? unquotedSource ?? trimmedValue)
    .replaceAll('&amp;', '&')
    .replaceAll('&#38;', '&')
}
